import { render, staticRenderFns } from "./PropertySection.vue?vue&type=template&id=0ce0e7a5&"
import script from "./PropertySection.vue?vue&type=script&lang=js&"
export * from "./PropertySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports